/**
 * Parsers puros de URLs do Google Maps usados pelo fluxo de geolocalização
 * do formulário de unidade.
 */

export type GoogleMapsCoordinates = { lat: number; lng: number }

/**
 * Extrai coordenadas de uma URL completa do Google Maps.
 * Formatos suportados: `/@lat,lng`, `?q=lat,lng` (ou `&q=`), `!3dlat!4dlng`.
 * Retorna `null` quando nenhum formato casa.
 */
export function parseGoogleMapsUrl(url: string): GoogleMapsCoordinates | null {
  const atMatch = url.match(/@(-?\d+\.?\d*),(-?\d+\.?\d*)/)
  if (atMatch) {
    return { lat: parseFloat(atMatch[1]), lng: parseFloat(atMatch[2]) }
  }

  const qMatch = url.match(/[?&]q=(-?\d+\.?\d*),(-?\d+\.?\d*)/)
  if (qMatch) {
    return { lat: parseFloat(qMatch[1]), lng: parseFloat(qMatch[2]) }
  }

  const dataMatch = url.match(/!3d(-?\d+\.?\d*)!4d(-?\d+\.?\d*)/)
  if (dataMatch) {
    return { lat: parseFloat(dataMatch[1]), lng: parseFloat(dataMatch[2]) }
  }

  return null
}

/** Links encurtados do Maps precisam ser resolvidos antes do parse. */
export function isShortGoogleMapsUrl(url: string): boolean {
  return url.includes('maps.app.goo.gl') || url.includes('goo.gl/maps')
}
